import * as React from 'react';

import Link16 from './Link16';

export const link16 = () => <Link16 />;

export default {
    title: 'Icon|Line|Link16',
    component: Link16,
    parameters: {
        notes: "`import Link16 from 'box-ui-elements/es/icon/line/Link16';`",
    },
};
